exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__logoWrapper___Jhg0E{display:flex}.styles__subNavigation___YnKZb{position:relative}.styles__subNavigation___YnKZb a{text-decoration:none}.styles__subNavigation___YnKZb a:hover{text-decoration:underline}.styles__subNavigation___YnKZb>div+div{left:inherit;min-width:100%;right:0;top:2.5rem;width:11rem}.styles__projectVersion___2biaX{font-weight:normal;font-size:.7rem;margin-left:.5rem}", ""]);

// Exports
exports.locals = {
	"logoWrapper": "styles__logoWrapper___Jhg0E",
	"subNavigation": "styles__subNavigation___YnKZb",
	"projectVersion": "styles__projectVersion___2biaX"
};